import React from 'react'
import Condition from 'components/Condition'
import { graphql, useFragment } from 'react-relay'
import { AvailabilityAndPositionTypeFields_User$key } from '__generated__/AvailabilityAndPositionTypeFields_User.graphql'
import AvailabilityEditDialog from './components/AvailabilityEditDialog'
import AvailabilityBadge from './components/AvailabilityBadge'

export interface IAvailabilityAndPositionTypeFieldsProps {
  editable: boolean
  user: AvailabilityAndPositionTypeFields_User$key
}

function AvailabilityAndPositionTypeFields({ editable, user: userFragmentRef }: IAvailabilityAndPositionTypeFieldsProps) {
  const [isEditOpen, setEditOpen] = React.useState(false)

  const user = useFragment(graphql`
    fragment AvailabilityAndPositionTypeFields_User on User {
      ...AvailabilityEditDialog_User
      ...AvailabilityBadge_User
    }
  `, userFragmentRef)

  return (
    <React.Fragment>
      <AvailabilityBadge
        editable={editable}
        user={user}
        onEditOpen={() => setEditOpen(true)}
      />

      <Condition condition={isEditOpen}>
        <AvailabilityEditDialog
          user={user}
          onClose={() => setEditOpen(false)}
        />
      </Condition>
    </React.Fragment>
  )
}

export default React.memo(AvailabilityAndPositionTypeFields)
